export const FirebaseAnalyticsEvent = {
	CLICK_TO_ACCOUNT: 'click_to_account',
	CLICK_ANDROID: 'click_android',
	CLICK_APPSTORE: 'click_appstore',
} as const;

export type FirebaseAnalyticsEvent = typeof FirebaseAnalyticsEvent[keyof typeof FirebaseAnalyticsEvent];
